import Vue from 'vue';
import Router from 'vue-router';
import * as config from '@/utils/config';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: config.ROUTER_BASE
});
